import { forwardRef } from 'react';

import { Link } from 'react-router-dom';

import { SVGAsset } from 'components/atoms/SVGAsset';

import { HeaderWrapper, TitleWrapper, PreTitle, Title } from './Header.styled';

type HeaderProps = React.HTMLProps<HTMLDivElement>;

export const Header = forwardRef<HTMLDivElement, HeaderProps>(
    (props, ref): JSX.Element => {
        return (
            <HeaderWrapper ref={ref}>
                <Link className="logo_wrapper" to="/">
                    <SVGAsset src="logos.mprlogo" />
                </Link>
                <TitleWrapper>
                    <PreTitle>
                        Государственный доклад <span>2021</span>
                    </PreTitle>
                    <Title>
                        О состоянии и об охране окружающей среды Российской
                        Федерации в 2021 году
                    </Title>
                </TitleWrapper>
            </HeaderWrapper>
        );
    }
);
